module.exports = __webpack_public_path__ + "static/media/Roboto-Condensed.e6fd95f0.ttf";